import axiosInstance from "../server/axios";

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export const getTypes = async () => {
  const response = await axiosInstance.get('/getAllTypeOffers', {
    headers: getAuthHeaders(),
  });
  return response.data; // Doit être un tableau
};

export const getOffresByType = async (typeId) => {
  const response = await axiosInstance.get(`/offres/type/${typeId}/with-average`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateAverageAmount = async (data) => {
  const response = await axiosInstance.post('/average-amounts', data, {
    headers: getAuthHeaders(),
  });
  return response.data;
};
